<template>
  <div>
    <Head :title="title" />
    <div class="max-w-4xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8">
          <h2 class="font-bold text-lg mb-1">{{ language_data.name }}</h2>
          <p class="text-gray-500 text-sm mb-6">{{ __('Code') }}: {{ language_data.code }}</p>

          <input
            v-model="search"
            type="text"
            :placeholder="__('Search translations...')"
            class="form-input w-full mb-4"
          />

          <div class="border rounded-md divide-y max-h-[32rem] overflow-y-auto">
            <div v-for="entry in filteredValues" :key="entry.name" class="grid grid-cols-2 gap-4 px-4 py-3">
              <div class="text-sm text-gray-600 self-center break-words">{{ entry.name }}</div>
              <input v-model="entry.value" type="text" class="form-input w-full" />
            </div>
            <div v-if="filteredValues.length === 0" class="px-4 py-6 text-center text-gray-500 text-sm">
              {{ __('No translations match your search.') }}
            </div>
          </div>
          <div v-if="form.errors.language_values" class="form-error mt-2">{{ form.errors.language_values }}</div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Update Language') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  layout: Layout,
  props: {
    language_data: Object,
    title: String,
  },
  data() {
    return {
      search: '',
      form: this.$inertia.form({
        _method: 'put',
        language_values: this.language_data.data.map((entry) => ({ ...entry })),
      }),
    }
  },
  computed: {
    filteredValues() {
      if (!this.search) {
        return this.form.language_values
      }
      const needle = this.search.toLowerCase()
      return this.form.language_values.filter((entry) => entry.name.toLowerCase().includes(needle))
    },
  },
  methods: {
    update() {
      this.form.post(this.route('languages.update', this.language_data.id))
    },
  },
}
</script>
